module.exports = __webpack_public_path__ + "img/weinintuijian.9304b556.svg";